module.exports = __webpack_public_path__ + "static/media/history_3.40382a84.jpg";